import HttpService from "./htttp.service";

class AuthService {

  login = async (payload) => {
    const loginEndpoint = 'auth/login';
    return await HttpService.post(loginEndpoint, payload);
  };

  register = async (credentials) => {
    const registerEndpoint = 'auth/register';
    return await HttpService.post(registerEndpoint, credentials);
  };

logout = async () => {
  const logoutEndpoint = 'auth/logout';
  const token = localStorage.getItem('authToken');

  if (!token) {
    throw new Error("No token found, user is not logged in");
  }

  return await HttpService.post(logoutEndpoint, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


  acceptInvite = async (payload) => {
    const acceptinvite = 'accept-invite';
    return await HttpService.post(acceptinvite, payload);
  }

  forgotPassword = async (payload) => {
    const forgotPassword = 'password-forgot';
    return await HttpService.post(forgotPassword, payload);
  }

  resetPassword = async (credentials) => {
    const resetPassword = 'password-reset';
    return await HttpService.post(resetPassword, credentials);
  }

  getProfile = async () => {
    const getProfile = 'auth/profile';
    return await HttpService.get(getProfile);
  }

  updateProfile = async (newInfo) => {
    const updateProfile = "auth/update";
    return await HttpService.patch(updateProfile, newInfo);
  }
}

export default new AuthService();
